import React from 'react';
/* import logo from './logo.svg'; */

import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import AboutUs from './components/AboutUs';
import NotFound from './components/NotFound';
import MakeTest from './components/MakeTest';
import TwelveColors from './components/TwelveColors';
import Instruccions from './components/Instruccions';
import Thanks from './components/Thanks';
import Results from './components/Results';


function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Instruccions} />
          <Route exact path="/about-us" component={AboutUs} />
          <Route exact path="/instructions" component={Instruccions} />
          <Route exact path="/colors" component={TwelveColors} />
          <Route exact path="/make-test" component={MakeTest} />
          <Route exact path="/results" component={Results} />
          <Route exact path="/thanks" component={Thanks} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>

    </div>
  );
}

export default App;
